import { useLayoutEffect, useState, type ReactNode } from 'react'
import { getMsgDeskRuntime } from '@/msgdeskRuntime'
import { bindDataTreeGlobalHooks, treeStore, type SubsStoreState } from '@/msgdeskRuntime/state'
import { SubsContext, useSubsStore } from '@/state/MsgTreeContext'
import { useInitialLegacyHtml } from '@/state/useInitialLegacyHtml'
import { useRuntimeUiFacade } from '@/state/useRuntimeUiFacade'

export { useSubsStore }

export function SubsManager({
  children,
  initialHtml,
  initialState,
}: {
  children: ReactNode
  initialHtml?: string | null
  initialState?: SubsStoreState | null
}) {
  // S1 (docs/27 §4): the server render uses the per-request initialState (the
  // singleton is shared across requests there and must stay untouched); the
  // client reads the singleton, which the island seeded synchronously from
  // the same payload before hydration, so both renders match.
  const [state, setState] = useState<SubsStoreState>(() => (
    typeof window === 'undefined' && initialState ? initialState : treeStore.getState()
  ))

  useLayoutEffect(() => {
    bindDataTreeGlobalHooks()
    const unsubscribe = treeStore.subscribe(() => {
      setState(treeStore.getState())
    })
    return unsubscribe
  }, [])

  useLayoutEffect(() => {
    treeStore.mutate.projectChromeState?.()
  }, [state.syncVersion])

  useInitialLegacyHtml(initialHtml)
  useRuntimeUiFacade()

  const actions = {
    removeSub: (elId: number) => {
      getMsgDeskRuntime().facade.removeSub(elId)
    },
  }

  return (
    <SubsContext.Provider value={{ state, actions }}>
      {children}
    </SubsContext.Provider>
  )
}
